// extracted by mini-css-extract-plugin
module.exports = {"circle":"styles_circle__AXZtM","badge":"styles_badge__p_OGq"};